<template>
  <section>
      <coach-filter @change-filter="setFilters"></coach-filter>
  </section>
  <section>
    <base-card>
        <div class="controls">
          <base-button mode="outline">새로고침</base-button>
           <!-- 본인이 코치로 등록 되어 있으면 등록 버튼 안보이게 -->
          <base-button link to="/main/register" v-if="!isCoach">코치로 등록</base-button>
        </div>
        <ul v-if="hasCoaches">
          <coach-item
            v-for="coach in filteredCoaches"
            :key="coach.id"
            :id="coach.id"
            :firstName="coach.firstName"
            :lastName="coach.lastName"
            :rate="coach.hourlyRate"
            :areas="coach.areas"
          ></coach-item>
        </ul>
        <h3 v-else>등록된 코치가 없습니다.</h3>
    </base-card>
  </section>
</template>

<script>
import CoachItem from "@/components/coaches/CoachItem.vue";
import CoachFilter from "@/components/coaches/CoachFilter"
export default {
  components: {
    CoachItem,
    CoachFilter
  },
  data(){
      return{
          activeFilters:{
            frontend:true,
            backend:true,
            career: true
          }
      }
  },
  computed: {
    isCoach() {
        return this.$store.getters['coaches/isCoach']
    },
    filteredCoaches() {
      const coaches = this.$store.getters["coaches/coaches"]; // 모듈명/불러올 getters
      return coaches.filter(coach =>{
        if(this.activeFilters.frontend && coach.areas.includes('frontend')){
            return true
            //includes 문자열이 특정 문자열을 포함하는지 확인하는 메서드입니다. IE는 Edge부터 지원합니다.
        }
        if(this.activeFilters.backend && coach.areas.includes('backend')){
            return true
        }
        if(this.activeFilters.career && coach.areas.includes('career')){
            return true
        }
        return false;
      })
    },
    hasCoaches() {
      return this.$store.getters["coaches/hasCoaches"]; // 모듈명/불러올 getters
    },
  },
  methods:{
    setFilters(updatedFilters){
        this.activeFilters = updatedFilters
    }
  }
};
</script>

<style scoped>
ul {
  list-style: none;
  margin: 0;
  padding: 0;
}

.controls {
  display: flex;
  justify-content: space-between;
}
</style>
